export enum StatusWfm {
  OPEN = 'OPEN',
  CONTROLLO_PL = 'CONTROLLO_PL',
  CONTROLLO_CL = 'CONTROLLO_CL',
  CONTROLLO_CDG = 'CONTROLLO_CDG',
}
